import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/GlobalFooter")
);

const FooterEditConfig = {
  emptyLabel: "Footer",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = ({
  footerId,
  primaryLinks = [],
  featuredLinks = [],
  socialMediaIcons,
  footerDisclaimer,
  footerCategories = [],
  footerCopyright,
} = {}) => ({
  id: footerId,
  featuredLinks,
  categories: footerCategories?.map(({ ctaListTitle, ctaListItems = [] }) => ({
    title: ctaListTitle,
    links: ctaListItems,
  })),
  links: primaryLinks,
  social: socialMediaIcons,
  disclaimer: footerDisclaimer,
  copyright: footerCopyright,
});

const Footer = (props) => {
  if (props.hideNav || !props.footerMenu) {
    return null;
  }

  const data = transformData(props.footerMenu);

  return (
    <>
      <div id="footer-module">
        <div className="pn" />
      </div>
      <Component {...data} />
    </>
  );
};

export default withAemIntegration("lexus/components/footer")(
  Footer,
  FooterEditConfig
);
